import { IExcCategory } from 'onboarding/components/widgets/public/admin/exceptionsReasons/models'

import { TCategory, TSubcategory } from '../multipleCategories'

type TCategoryCode = string

const mapToSubCategoryNode = (category: IExcCategory): TSubcategory => ({
  title: category.Title,
  code: category.Code,
  guid: category.GUID,
})

export const mapToMultipleCategories = (categories: IExcCategory[]) => {
  const categoriesMap: Map<TCategoryCode, IExcCategory> = new Map(
    categories.map((i) => [i.Code, i])
  )
  const codesHierarchy: Map<TCategoryCode, Set<TCategoryCode>> = new Map()

  categories.forEach((category) => {
    if (category.ParentCode) {
      const subcategories = codesHierarchy.get(category.ParentCode) ?? new Set()
      subcategories.add(category.Code)
      codesHierarchy.set(category.ParentCode, subcategories)
    } else {
      if (!codesHierarchy.has(category.Code)) {
        codesHierarchy.set(category.Code, new Set())
      }
    }
  })

  const result: TCategory[] = []
  for (const [categoryCode, subcategoriesCodes] of codesHierarchy) {
    const category = categoriesMap.get(categoryCode)
    if (category) {
      const subcategoriesNodes: TSubcategory[] = []
      Array.from(subcategoriesCodes).forEach((subcategoryCode) => {
        const subcategory = categoriesMap.get(subcategoryCode)
        if (subcategory) {
          subcategoriesNodes.push(mapToSubCategoryNode(subcategory))
        }
      })
      result.push({
        ...mapToSubCategoryNode(category),
        description: category.Description || '',
        guidelines: category.Guidelines || '',
        justification: category.Justification || '',
        subcategories: subcategoriesNodes,
      })
    }
  }

  return result
}
